export const NUMBER_OF_EVENTS = 10000
